var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.97224C20.0036 11.3654 19.6781 12.7398 19.05 13.9833C18.3052 15.4735 17.1603 16.7269 15.7434 17.6031C14.3265 18.4794 12.6937 18.9438 11.0278 18.9444C9.63457 18.9481 8.26022 18.6226 7.01666 17.9944L1 20L3.00555 13.9833C2.37743 12.7398 2.05192 11.3654 2.05555 9.97224C2.0562 8.30632 2.52064 6.67348 3.39687 5.2566C4.27309 3.83973 5.52648 2.69479 7.01666 1.95003C8.26022 1.3219 9.63457 0.996398 11.0278 1.00003H11.5555C13.7557 1.12141 15.8337 2.05005 17.3918 3.60815C18.9499 5.16626 19.8786 7.24432 20 9.44446V9.97224Z",
    stroke: "#637588",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.29329020e6f0bee38e0499cc62ae083d.svg";
export { ForwardRef as ReactComponent };